BusinessClassAdView = require 'views/ads/business-class-ad-view'
BusinessClassGoogleAppsAdView = require 'views/ads/business-class-google-apps-ad-view'
_ = require 'underscore'

module.exports = new class
  _findAd: (ads, member, args...) ->
    _.find ads, (ad) ->
      !member.isAdDismissed(ad.adId) && ad.isEligible(member, args...)

  # Our A/B test indicates that people are about 30% more likely to get BC
  # if they see this ad
  addMemberToOrganizationAd: (member, organization) ->
    @_findAd [
      BusinessClassGoogleAppsAdView
    ], arguments...

  boardsListAd: (member, board) ->
    @_findAd [
      BusinessClassAdView
    ], arguments...



// WEBPACK FOOTER //
// ./app/scripts/views/ads/ad-views.coffee